module.exports = __webpack_public_path__ + "img/invoice1.a195f7de.png";